<template>
  <v-layout align-center justify-center row fill-height class="ma-0 grey lighten-1">
    <v-card>
      <v-card-text class="text-center">
        <v-progress-circular indeterminate class="ma-auto"></v-progress-circular>
      </v-card-text>
      <v-card-text>
        <div class="text-caption">Logging Out...</div>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script lang="ts">
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class LogOut extends Vue {

}
</script>